import { forwardRef } from 'react'
import { useTheme } from 'styled-components'

import { VipSectionContainerMobile } from '@/components/vip/vip-features-buttons/styled'
import { RequestViewing } from '@/features/listing/components/request-viewing/RequestViewing'
import { isListingEligibleForRequestViewing } from '@/features/listing/utils/request-viewing/isListingEligibleForRequestViewing'
import { RemoteParamKeys, useToggle } from '@/lib/firebase/hooks'
import { type VipQueryListing } from '@/types/listings'
import { Flex } from '@/ui/atoms/flex'

type VipFeaturesButtonsProps = {
  listing: VipQueryListing
}

export const VipFeatureButtons = forwardRef<HTMLDivElement, VipFeaturesButtonsProps>(
  ({ listing }, ref) => {
    const { spacing } = useTheme()
    const vipRequestViewingToggle = useToggle(RemoteParamKeys.VIP_REQUEST_VIEWING)
    const isRequestViewingToggleEnabled = vipRequestViewingToggle?.enabled === true

    const shouldShowRequestViewing =
      isListingEligibleForRequestViewing(listing) && isRequestViewingToggleEnabled

    /* 
      For now we only want to show this section only if there's a Request a Viewing feature available given the 
      current category. As per designs, a phone button will be added in the future, adjust the condition accordingly.
    */
    return shouldShowRequestViewing ? (
      <VipSectionContainerMobile pTop={spacing.default} pBottom={spacing.default} ref={ref}>
        <Flex gap={spacing.default}>
          <RequestViewing listing={listing} source="VIP" />
        </Flex>
      </VipSectionContainerMobile>
    ) : null
  }
)

VipFeatureButtons.displayName = 'VipFeatureButtons'
